/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PerformanceIndicatorDto
 */
export interface PerformanceIndicatorDto {
    /**
     * 
     * @type {Date}
     * @memberof PerformanceIndicatorDto
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof PerformanceIndicatorDto
     */
    idle?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceIndicatorDto
     */
    low?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceIndicatorDto
     */
    medium?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceIndicatorDto
     */
    high?: number | null;
}

export function PerformanceIndicatorDtoFromJSON(json: any): PerformanceIndicatorDto {
    return PerformanceIndicatorDtoFromJSONTyped(json, false);
}

export function PerformanceIndicatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformanceIndicatorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'idle': !exists(json, 'idle') ? undefined : json['idle'],
        'low': !exists(json, 'low') ? undefined : json['low'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'high': !exists(json, 'high') ? undefined : json['high'],
    };
}

export function PerformanceIndicatorDtoToJSON(value?: PerformanceIndicatorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'idle': value.idle,
        'low': value.low,
        'medium': value.medium,
        'high': value.high,
    };
}


